import PlaybackFeed from './playback-feed';
import BroadcastFeed from './broadcast-feed';
import Feed from './feed';

export default function buildFeed(feedable, options = {}) {
  let kind = detectFeedKind(feedable);
  if (kind === 'playback')  return new PlaybackFeed(feedable, options);
  if (kind === 'broadcast') return new BroadcastFeed(feedable, options);
  return new Feed(feedable, options);
}

function detectFeedKind(obj) {
  let modelName = obj?.constructor?.modelName;
  if (modelName === 'airing') return 'playback';
  if (modelName === 'now-playing' || modelName === 'nowPlaying') return 'broadcast';

  if (obj?.startsAt && obj?.endsAt) return 'playback';
  if (obj?.streamUrl) return 'broadcast'
  return 'unknown';
}
